import Mock from "mockjs2";
import { ReturnMessage, getQueryParameters } from "../util";

const totalCount = 5701;

const serverList = options => {
  const parameters = getQueryParameters(options);

  const result = [];
  const pageNo = parseInt(parameters.pageNo);
  const pageSize = parseInt(parameters.pageSize);
  const totalPage = Math.ceil(totalCount / pageSize);
  const key = (pageNo - 1) * pageSize;
  const next = (pageNo >= totalPage ? totalCount % pageSize : pageSize) + 1;

  for (let i = 1; i < next; i++) {
    const tmpKey = key + i;
    result.push({
      key: tmpKey,
      id: tmpKey,
      userName: "姓名" + tmpKey,
      number: Mock.mock("@integer(1,999999)"),
      sex: i % 2 ? "W" : "M",
      telphone: Mock.mock("@integer(11111111111,19999999999)"),
      status: Mock.mock("@integer(0, 3)"),
      age: Mock.mock("@integer(0, 99)"),
      updatedAt: Mock.mock("@datetime"),
      editable: false
    });
  }

  return ReturnMessage({
    pageSize: pageSize,
    pageNo: pageNo,
    totalCount: totalCount,
    totalPage: totalPage,
    data: result
  });
};

Mock.mock(/\/service/, "get", serverList);
